import cookie from './cookie.js'
import { REGION } from '@ms/config/app'

// session loginStatus key
const KEY_LOGIN_STATUS = `${REGION}-au`

export const setSessionLoginStatus = (localStatus = false) => {
  if (localStatus) {
    sessionStorage.setItem(KEY_LOGIN_STATUS, true)
    window.loginStatus = localStatus
  } else {
    sessionStorage.removeItem(KEY_LOGIN_STATUS)
  }
}

// 检测用户登录态
export const checkLoginStatus = () => {
  const localStatus = !!cookie.get('accessToken') && cookie.get('accessToken') !== '""'
  // 优先判断本地 session 是否存有登录态
  if ((window.loginStatus || sessionStorage.getItem(KEY_LOGIN_STATUS)) && localStatus) {
    window.loginStatus = true
    return true
  }
  // 优先使用后台模版传递的登录状态
  const authenticated = window.authenticated
  if (authenticated === 'true' || authenticated === 'false') {
    const loginStatus = authenticated === 'true'
    setSessionLoginStatus(loginStatus)
    return loginStatus
  }
  setSessionLoginStatus(localStatus)
  return localStatus
}
